import React, { useEffect, useState } from 'react';
import './AssignedSpace.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faSave, faEdit, faTrashCan, faRemove } from '@fortawesome/free-solid-svg-icons'; // Import appropriate icons
import { CustomOptionsDropdown } from './dropdown';
import { SelectionEvents, OptionOnSelectData } from '@fluentui/react-components';
import './timePicker.css'
import { Image } from "@fluentui/react-components";
import Sidenav from './sidebar';
import { DatePicker, DatePickerProps, Input } from 'antd';
import {
    Avatar,
    Menu,
    MenuTrigger,
    MenuList,
    MenuItem,
    MenuPopover,

} from "@fluentui/react-components";
import { useNavigate } from 'react-router-dom';
import { getSettings } from '../../viewmodel/getsettings';
import { DeleteAction } from '../dialogues/dialogue-delete';
import moment from 'moment';
import {
    Dropdown,
    makeStyles,
    Option,
    shorthands,
    useId,
} from "@fluentui/react-components";
import type { DropdownProps } from "@fluentui/react-components";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { RangePickerProps } from 'antd/es/date-picker';
import { CommonInfo } from '../../CommonData/Config';
import ToastrService from '../toaster/ToastrService';
import { log } from 'console';
import GetSettingsService from '../../APIService/mySettingsService';
import LoginService from '../../APIService/loginservice';
import Swal from 'sweetalert2';
import {useTranslation} from 'react-i18next';
import { ROUTES } from '../../CommonData/RouteConstants';

dayjs.extend(customParseFormat);
const getSettingsData = getSettings;
const { RangePicker } = DatePicker;
const Commondata = CommonInfo;

const initialSpaceTypes = [
    { spaceTypeName: 'Desk1.11', spacetype: 'Desk', Id: 1 },
    { spaceTypeName: 'Parking1234', spacetype: 'Parking', Id: 2 },
    // { spaceTypeName: 'Assigned Space', spacetype: 'assigned_space', Id: 3 },
    // { spaceTypeName: 'Room', spacetype: 'room', Id: 4 }
];
export const SpaceTypeDropdown = (props: Partial<DropdownProps>) => {
    const comboId = useId("combo-multi");
    const options = getSettings.MysettingsBasicdata?.[0].AssignedSpace.map((type: any) => type.ResName);
    return (

        <Dropdown
            className='spacetype_drop_down'
            aria-labelledby={comboId}
            multiselect={true}
            {...props}

        >
            {options.map((option: any) => (
                <Option key={option} >
                    {option}
                </Option>
            ))}
        </Dropdown>
    );
};

type AssignedSpaceDate = {
    StartDate: string;
    EndDate: string;
    Id: number;
    Action: string;
};

const AssignedSpacePage: React.FC = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [assignedspaceDates, setAssignedspaceDates] = useState<AssignedSpaceDate>({
        StartDate: '',
        EndDate: '',
        Id: 0,
        Action: ''
    });
    const [checkedOptions, setCheckedOptions] = useState<string[]>([]);

    const userIdString = localStorage.getItem('userId');
    const userEmail = localStorage.getItem('userEmail')
    const [dateRanges, setDateRanges] = useState<{ StartDate: string; EndDate: string; Id: number }[]>([
        { StartDate: '', EndDate: '', Id: 0 },
    ]);
    let userId: any;
    if (userIdString !== null) {
        userId = parseInt(userIdString);
    } else {
        console.error("userId is not found in localStorage");
    }

    const logOut = async () => {
        Swal.fire({
            title:t('LogoutConfirmation'),
            text: t('AreYouSureYouWantToLogout?'),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t('No'),
            confirmButtonColor: localStorage.getItem('Theme') === 'dark' ? "#124779" : "#000",
            cancelButtonColor: localStorage.getItem('Theme') === 'dark' ? "rgba(238, 238, 238, 0.20)" : "#bcc6d0;",
            customClass: {
                popup: localStorage.getItem('Theme') === 'dark' ? 'dark-theme' : 'light-theme'
            },
            confirmButtonText: t("Yes")
        }).then(async (result) => {
            if (result.isConfirmed) {
                const LogOut = await LoginService.logout();
                if (LogOut.data.ErrCode === '') {
                    localStorage.setItem('loggedIn', 'false');
                    navigate(ROUTES.LOGIN);
                }
            }
        });

    }
    const [formattype, setFormattype] = useState<string>(''); // Default format


    useEffect(() => {
        applyDarkTheme();
        getMySettings();
    }, []);
    const theme = localStorage.getItem('Theme')

    function applyDarkTheme() {
        if (localStorage.getItem('Theme') === 'dark') {
            document.querySelectorAll('.ant-picker-panel-container').forEach((element) => {
                element.classList.add('Dark_calendar');
            });

            const style = document.createElement('style');
            style.id = 'dynamic-theme-styles';
            style.innerHTML = `
                :where(.css-dev-only-do-not-override-m4timi).ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-in-range:not(.ant-picker-cell-disabled):before,
                :where(.css-dev-only-do-not-override-m4timi).ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-disabled):before,
                :where(.css-dev-only-do-not-override-m4timi).ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-disabled):before {
                    background-color: #2f4a5f !important;
                }
            `;
            document.head.appendChild(style);
            return () => {
                const existingStyle = document.getElementById('dynamic-theme-styles');
                if (existingStyle) {
                    document.head.removeChild(existingStyle);
                }
            };
        }
    }

    const deleteMessage1 = t('YouAboutToDeleteTheDataRelatedTo');
    const deleteMessage2 = t("ThisWillAlsoDeleteAllAssociatedDailyDataIncludingTheWorkplacePageAndSoForth");
    const deleteLabel = t("YesDeleteTheDataRelatedTo");
    const getMySettings = async () => {
        try {
            const getDataResult = await GetSettingsService.getMySettings(userId, userEmail);
            if (getDataResult.data.d) {
                await getAssignedspace()
                await GetMySettingsBasic()

            }
        } catch (error) {
        }
    };

    const setDateFormat = () => {
        const dateformat = localStorage.getItem('DateFormat')
        switch (dateformat) {
            case ('dd/MM/yyyy'):
                return 'DD/MM/YYYY';
            case ('MM/DD/YYYY'):
                return 'MM/DD/YYYY';
            case ('MMMM, DD, YYYY'):
                return 'MMMM, DD, YYYY';
            case ('MMMM, dddd D, YYYY'):
                return 'MMMM, dddd D, YYYY';
            case ('dddd, D MMMM YYYY'):
                return 'dddd, D MMMM YYYY';
            case ('dddd Do MMMM YYYY'):
                return 'DD/MM/YYYY';

            default:
                return 'DD/MM/YYYY';

        }

    }
    const dateFormat = setDateFormat();
    console.log(dateFormat, "dateFormat");

    const getAssignedspace = async () => {
        try {
            const data = {
                UserId: userId,
                EmailAddress: userEmail
            }
            const getDataResult = await GetSettingsService.AssignedSpaceService(data);
            if (getDataResult) {
                getSettingsData.AssignedSpacedata = getDataResult.data.d;
                const availableForColleagueDates = getSettingsData.AssignedSpacedata.AssignedSpace[0].AvailableForColleagueDates;
                console.log(availableForColleagueDates);


                const sortedExceptions = availableForColleagueDates.sort((a: { StartDate: string; }, b: { StartDate: string; }) => {
                    // Convert the StartDate to a valid date format (YYYY-MM-DD)
                    const dateA: Date = new Date(a.StartDate.split('/').reverse().join('-'));
                    const dateB: Date = new Date(b.StartDate.split('/').reverse().join('-'));

                    // If either date is invalid (NaN), handle it by placing it at the end
                    if (isNaN(dateA.getTime())) return 1; // Move invalid dateA to the end
                    if (isNaN(dateB.getTime())) return -1; // Move invalid dateB to the end

                    return dateA.getTime() - dateB.getTime(); // Sort by Date
                });
                sortedExceptions.unshift({ StartDate: '', EndDate: '', Id: 0 })

                console.log("sortedExceptions", sortedExceptions);

                const formattedDates = sortedExceptions.map((entry: any) => {
                    if (entry.StartDate) {
                        entry.StartDate = dayjs(entry.StartDate, 'DD/MM/YYYY').format(dateFormat);
                    }
                    if (entry.EndDate) {
                        entry.EndDate = dayjs(entry.EndDate, 'DD/MM/YYYY').format(dateFormat);
                    }
                    return entry;
                });

                setDateRanges(formattedDates);

            }

        } catch (error) {
            console.error('Error in my settings:', error);
        }
    };

    const GetMySettingsBasic = async () => {
        try {
            const getResult = await GetSettingsService.GetSettingsBasic(userId, userEmail)
            if (getResult.data.d) {
                getSettingsData.MysettingsBasicdata = getResult.data.d;

            }
        } catch (error) {

        }
    }

    const handleDateChange = (dates: [Date | null, Date | null], dateStrings: any, index: any, Id: number) => {
        // document.querySelectorAll('.ant-picker-input').forEach((element) => {
        //     element.classList.add('col-5');
        // });
        const startDate = dateStrings[0];
        const endDate = dateStrings[1];

        const overlapsExistingRange = dateRanges.some((range, i) => {
            if (i !== index) {
                let rangeStartDate = dayjs(range.StartDate, dateFormat);
                let rangeEndDate = dayjs(range.EndDate, dateFormat);
                return (
                    (startDate && endDate &&
                        dayjs(startDate, dateFormat).isBefore(rangeEndDate.add(1, 'day')) &&
                        dayjs(endDate, dateFormat).isAfter(rangeStartDate.subtract(1, 'day'))) ||
                    (startDate && !endDate &&
                        dayjs(startDate, dateFormat).isBefore(rangeEndDate.add(1, 'day')) &&
                        dayjs(startDate, dateFormat).isAfter(rangeStartDate.subtract(1, 'day'))) ||
                    (!startDate && endDate &&
                        dayjs(endDate, dateFormat).isBefore(rangeEndDate.add(1, 'day')) &&
                        dayjs(endDate, dateFormat).isAfter(rangeStartDate.subtract(1, 'day'))) ||
                    (!startDate && !endDate)
                );
            }
            return false;
        });

        if (overlapsExistingRange) {
            ToastrService.warning(t('SelectedDateRangeOverlapsWithExistingRange'))
            return ('');
        }
        const newDateRanges = dateRanges.map((range, i) => {
            if (i === index) {
                return {
                    ...range,
                    StartDate: startDate,
                    EndDate: endDate
                };
            }
            return range;
        });

        setDateRanges(newDateRanges);
        const action = "Edit"; // Define the action value as needed
        setAssignedspaceDates({ StartDate: startDate, EndDate: endDate, Id, Action: action });
    };

    const getIndex = (StartDate: any, EndDate: any, Id: number, index: number, Action: string) => {

        if (!(getSettingsData.AssignedSpacedata?.AssignedSpace?.length > 0) || // Disable if no AssignedSpace data
            (getSettingsData.AssignedSpacedata?.AssignedSpace[0]?.AvailableForColleagueDates.length > 1 && index !== currentIndex)) {
            if (localStorage.getItem('Theme') === 'dark') {
                document.body.classList.add('dark-theme');
            }
            if (StartDate && dayjs(StartDate, dateFormat).isBefore(dayjs(), 'day') && EndDate && dayjs(EndDate, dateFormat).isBefore(dayjs(), 'day') && Action == "Edit") {
                ToastrService.warning(t('PreviousDatesCannotBeEdited'))
            }
            else {
                const action = "Edit"; // Define the action value as needed
                setAssignedspaceDates({ StartDate: StartDate, EndDate: EndDate, Id, Action: action });
                setCurrentIndex(index);
            }
        }


    }

    const handleDelete = async (StartDate: any, EndDate: any, Id: number, index: number) => {
        const action = 'Remove';
        setAssignedspaceDates({ StartDate, EndDate, Id, Action: action });
        await Change(StartDate, EndDate, Id, action)

        // setDateRanges((prevDates) => prevDates.filter((_, i) => i !== index));

    };

    const ChangeDateFormat = () => {
        const updatedWorkLocations = dateRanges.map((item) => ({
            ...item,
            StartDate: parseAndFormatDate(item.StartDate),
            EndDate: parseAndFormatDate(item.EndDate),
        }));


        return updatedWorkLocations;
    }


    function parseAndFormatDate(date: string | number | Date | dayjs.Dayjs | null | undefined) {

        const parsedDate = dayjs(date, dateFormat, true); // Strict mode
        if (parsedDate.isValid()) {
            return parsedDate.format("DD/MM/YYYY");
        }
        // If no format matches, return the original date
        return dayjs(date).isValid() ? dayjs(date).format("DD/MM/YYYY") : date;
    }

    const ChangeFormat = () => {

        const updatedAssignedspaceDates = {
            ...assignedspaceDates,
            StartDate: parseAndFormatDate(assignedspaceDates.StartDate),
            EndDate: parseAndFormatDate(assignedspaceDates.EndDate),
        };

        return updatedAssignedspaceDates;
    }

    const Change = async (StartDate: any, EndDate: any, Id: number, Action: any) => {
        const updatedAssignedspaceDates = {
            ...assignedspaceDates,
            StartDate: parseAndFormatDate(StartDate),
            EndDate: parseAndFormatDate(EndDate),
            Id: Id,
            Action: Action
        };
        // setAssignedspaceDates(updatedAssignedspaceDates);

        // return updatedAssignedspaceDates;

        try {
            const data = {
                UserId: userId,
                EmailAddress: userEmail,
                ResId: getSettingsData.AssignedSpacedata.AssignedSpace[0].ResId,
                AvailabilityEvent: updatedAssignedspaceDates,

            }
            console.log(data, "data");
            const getDataResult = await GetSettingsService.SetAssignedSpaceAvailablity(data);
            if (getDataResult.data && getDataResult.data?.d.Success) {
                ToastrService.success(t('YourAssignedSpaceAvailablityHaveBeenDeletedSuccessfully'));
                getAssignedspace()
            } else {
                ToastrService.error(getDataResult.data?.d.ErrDesc);
            }
        } catch (error) {
            console.error('Error in Work Places:', error);
        }
    }

    const handleSave = async (StartDate: any, EndDate: any, Id: number, i: number) => {
        // document.querySelectorAll('.ant-picker-input').forEach((element) => {
        //     element.classList.add('col-5');
        // });

        if (StartDate && EndDate && i === 0) {
            dateRanges.forEach((v: any) => {
                v.Action = "Add";
            });
            const updateddateranges = ChangeDateFormat()
            console.log(assignedspaceDates, "assignedspaceDates");

            try {
                const data = {
                    UserId: userId,
                    EmailAddress: userEmail,
                    ResId: getSettingsData.AssignedSpacedata.AssignedSpace[0].ResId,
                    AvailabilityEvent: updateddateranges[0],

                }
                const getDataResult = await GetSettingsService.SetAssignedSpaceAvailablity(data);
                if (getDataResult.data && getDataResult.data?.d.Success) {
                    setDateRanges((prevDates) => [
                        { StartDate: '', EndDate: '', Id: 0 },
                        { StartDate, EndDate, Id },
                        ...prevDates.slice(1)
                    ].sort((a, b) => (a.StartDate > b.StartDate ? 1 : -1)));

                    ToastrService.success(t('YourAssignedSpaceAvailablityHaveBeenSaved'));
                    getAssignedspace()
                } else {
                    ToastrService.error(getDataResult.data?.ErrDesc);
                }
            } catch (error) {
                console.error('Error in Work Places:', error);
                ToastrService.error(t('CannotReadPropertiesOfNull'));

            }
        } else if (StartDate && EndDate && i !== 0) {

            const updatedAssignedspaceDates = ChangeFormat()
            try {
                const data = {
                    UserId: userId,
                    EmailAddress: userEmail,
                    ResId: getSettingsData.AssignedSpacedata.AssignedSpace[0].ResId,
                    AvailabilityEvent: updatedAssignedspaceDates,

                }
                console.log(data, "data");
                const getDataResult = await GetSettingsService.SetAssignedSpaceAvailablity(data);
                if (getDataResult.data && getDataResult.data?.d.Success) {
                    ToastrService.success(t('YourAssignedSpaceAvailablityHaveBeenSaved'));
                    getAssignedspace()
                } else {
                    ToastrService.error(getDataResult.data?.d.ErrDesc);
                }
            } catch (error) {
                console.error('Error in Work Places:', error);
            }

            setDateRanges((prevDates) => [
                ...prevDates.sort((a, b) => (a.StartDate > b.StartDate ? 1 : -1))
            ]);
            console.log(dateRanges, "dateranges");

            setCurrentIndex(0);
        } else {
            ToastrService.warning(t('PleaseSelectAllTheFields'));
        }
    };;

    const isDayDisabled = (date: any) => {

        const workingDays = getSettingsData.MysettingsBasicdata[0]?.WorkingDays || {};
        const dayOfWeek = dayjs(date).format('dddd');
        return workingDays[dayOfWeek] === false;
    };

    function FormatDate(date: string | number | Date | dayjs.Dayjs | null | undefined) {
        // Try parsing with multiple formats
        let parsedDate = dayjs(date, dateFormat, true); // Strict mode
        if (parsedDate.isValid()) {
            return parsedDate; // Return the parsed date as a dayjs object
        }
        // If no format matches, return a dayjs object (fallback)
        return dayjs(date);
    }


    const disabledDate: RangePickerProps['disabledDate'] = (current, date: any) => {
        const disabledDates = dateRanges.map((dateRange, index) => {
            let startDate = FormatDate(dateRange.StartDate);
            let endDate = FormatDate(dateRange.EndDate);

            // If the date parsing was unsuccessful (invalid dayjs objects), handle this scenario
            if (!startDate.isValid() || !endDate.isValid()) {
                return null; // Skip invalid ranges
            }

            // Check if the date range is in the other format (index comparison)
            if (currentIndex !== index) {
                return { startDate, endDate };
            }
        }).filter(Boolean); // Remove any null values from invalid date ranges

        const currentDay = dayjs().startOf('day');

        // Disable dates that are before the current date
        if (current && current.isBefore(currentDay, 'day')) {
            return true;
        }

        const isDisabled = disabledDates.some((dateRange) => {
            return current.isAfter(dateRange?.startDate.subtract(1, 'day')) && current.isBefore(dateRange?.endDate.add(1, 'day'));
        });

        const workingDays = getSettingsData.MysettingsBasicdata[0]?.WorkingDays || {};
        const dayOfWeek = dayjs(current).format('dddd');
        console.log("workingDays[dayOfWeek] === false", workingDays[dayOfWeek] === false);

        return (workingDays[dayOfWeek] === false) || current && isDisabled;
    };


    // const SpaceTypesselct = (data: any, index: number) => {
    //     console.log(data, "SpaceTypesselct");
    //     setDateRanges((prevRanges) => [
    //         ...prevRanges.slice(0, index),
    //         {
    //             ...prevRanges[index],
    //             SpaceTypes: data.selectedOptions,
    //         },
    //         ...prevRanges.slice(index + 1),
    //     ]);



    const handleOptionClick = (option: string) => {
        // Toggle the checked status of the clicked option
        if (checkedOptions.includes(option)) {
            setCheckedOptions(checkedOptions.filter(item => item !== option));
        } else {
            setCheckedOptions([...checkedOptions, option]);
        }
    };

    const clearDateRange = (index: number) => {
        // Create a new array with the cleared range
        const updatedDateRanges = dateRanges.map((range, i) => {
            if (i === index) {
                return { ...range, StartDate: "", EndDate: "" };
            }
            return range;
        });
        // Set the new state
        setDateRanges(updatedDateRanges);
    };


    return (
        <div className={`sidenav-container`}>
            <Sidenav authToken={null} LoguserName={null} />
            <div className={theme === 'dark' ? 'main-content_dark' : 'main-content'}>
                <div className="row">
                    <div className="col-10 px-4">
                        <label className='head'>{t('AssignedWorkspace')}</label>
                    </div>
                    <div className="col-2 right px-4  ">
                        <Menu>
                            <MenuTrigger disableButtonEnhancement>
                                <Avatar
                                    name={localStorage.getItem('UserName')?.toString()}
                                    image={{
                                        src: getSettingsData.data && getSettingsData.data.UserImage && getSettingsData.data.UserImage.Value
                                            ? getSettingsData.data.UserImage.Value
                                            : "",
                                    }}
                                    style={{
                                        cursor: "pointer", width: "45px", height: "43px"
                                    }}
                                    shape="circular"
                                />
                            </MenuTrigger>
                            <MenuPopover className='mt-2' style={{ width: "14rem" }}>
                                <MenuList>
                                    {/* <MenuItem style={{ fontSize: "14px" }} ><Image id="img" className='pointer' src={Commondata.folderName + "resetpassword.svg"} />&nbsp;&nbsp;Reset password</MenuItem> */}
                                    <MenuItem onClick={logOut} style={{ fontSize: "14px" }} ><Image id="img" className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/Logoutlight.svg' : '/logout.svg'}`} />&nbsp;&nbsp;{t('LogOut')}</MenuItem>
                                </MenuList>
                            </MenuPopover>
                        </Menu>
                        {ToastrService.getToastrComponent()}
                    </div>
                </div>
                <div className="container">
                    <div className="row mt-5">
                        <div className="col-md-2"></div>
                        <div className="col-md-8">
                            <div className='row mb-2 mt-3'><h5 className='p-0'>{t('AssignedSpace')}</h5></div>
                            {/* <div className="row mb-3 px-1">
                                <div className="col-md-10 mt-3">
                                    <label className='label-head lock-icon'>
                                        <span >Office location</span></label>
                                    <input className="inputBox" type="text" value={workplace} readOnly />
                                </div>
                                <div className="col-md-2 mt-5">
                                    <button className='button'><FontAwesomeIcon icon={faPencil} className='icon' />Update</button>
                                </div>
                            </div> */}
                            {/* <div className="row mb-3 px-1">
                                <div className="col-md-8">
                                    <div className="col-md-12">
                                        <label className='label-head lock-icon'><Image id="lockicon" className='pointer' src={Commondata.folderName + "lock.svg"} />
                                            <span className='mar-left'>Workspace name</span></label>
                                        <input className="inputBox" type="text" value={getSettingsData.AssignedSpacedata.AssignedSpace.ResName} readOnly />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="col-md-12">
                                        <label className='label-head lock-icon'><Image id="lockicon" className='pointer' src={Commondata.folderName + "lock.svg"} />
                                            <span className='mar-left'>Space type</span></label>
                                        <input className="inputBox" type="text" value={getSettingsData.AssignedSpacedata.AssignedSpace.ResName} readOnly />
                                    </div>
                                </div>
                            </div> */}
                            <div >

                                <div className="row mb-3 px-1" >
                                    <div className="col-md-8">
                                        <div className="col-md-12">
                                            <label className={theme === 'dark' ? 'Assignspace_label_dark lock-icon' : 'Assignspace_label lock-icon'}><Image id={theme === 'dark' ? 'lockicon-dark' : "lockicon"} className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/Locklight.svg' : '/lock.svg'}`} />
                                                <span className='Assignspace_mar-left'>{t('WorkspaceName')}</span></label>
                                            {getSettingsData.AssignedSpacedata?.AssignedSpace ? getSettingsData.AssignedSpacedata?.AssignedSpace.length <= 0 ? (

                                                <h6 className="mt-3">{t('NoDataAvailableContactYourAdministratorToUpdateTheseSettings')}</h6>

                                            ) : (
                                                <input
                                                    className={theme === 'dark' ? 'inputBox_dark' : 'inputBox'}
                                                    type="text"
                                                    value={getSettingsData.AssignedSpacedata?.AssignedSpace[0]?.ResName}
                                                    readOnly
                                                />
                                            ) : <h6 className="mt-3">{t('NoDataAvailableContactYourAdministratorToUpdateTheseSettings')}</h6>
                                            }


                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="col-md-12">
                                            <label className={theme === 'dark' ? 'Assignspace_label_dark lock-icon' : 'Assignspace_label lock-icon'}><Image id={theme === 'dark' ? 'lockicon-dark' : "lockicon"} className='pointer' src={`${CommonInfo.folderName}${theme === 'dark' ? '/Locklight.svg' : '/lock.svg'}`} />
                                                <span className='Assignspace_mar-left'>Space type</span></label>
                                            {getSettingsData.AssignedSpacedata?.AssignedSpace ? getSettingsData.AssignedSpacedata?.AssignedSpace.length <= 0 ? (

                                                <h6 className="mt-3">{t('NoDataAvailableContactYourAdministratorToUpdateTheseSettings')}</h6>

                                            ) : (<input className={theme === 'dark' ? 'inputBox_dark' : "inputBox"} type="text"
                                                value={getSettingsData.AssignedSpacedata?.AssignedSpace[0]?.SpaceType} readOnly />
                                            ) : <h6 className="mt-3">{t('NoDataAvailableContactYourAdministratorToUpdateTheseSettings')}</h6>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mt-3'><h5 className='p-0 mb-0'>{t('AvailableForColleagues')}</h5></div>
                            <div className="row mb-3 px-0">
                                <label className='label_text mt-3 '>{t('AddDatesThatYouDontNeedYourAssignedSpaceThisWillAllowYourColleaguesUseTheSpaceInYourAbsence')}</label>
                            </div>
                            {dateRanges.map((range, index) => (
                                <div key={index} className="row mb-2 px-0">
                                    <div className={theme === 'dark' ? 'ant_pickerdark col-md-5 col-sm-12' : "col-md-5 col-sm-12"}>
                                        {index === 0 && <label className={theme === 'dark' ? 'label-head_dark  view' : 'label-head  view'}>{t('StartDate')}</label>}
                                        {index === 0 && (
                                            <div className="label-container Tab_view">
                                                <span className="label-head">{t('StartDate')}</span>
                                                <span className="label-head_web_view">{t('EndDate')}</span>
                                            </div>
                                        )}
                                        <div className="row">
                                            <div className='col-sm-10 d-flex'>
                                                <RangePicker
                                                    disabled={
                                                        !(getSettingsData.AssignedSpacedata?.AssignedSpace?.length > 0) || // Disable if no AssignedSpace data
                                                        (getSettingsData.AssignedSpacedata?.AssignedSpace[0]?.AvailableForColleagueDates.length > 1 && index !== currentIndex) // Disable based on AvailableForColleagueDates and index
                                                    }
                                                    disabledDate={disabledDate}
                                                    onClick={() => {
                                                        // Check if the RangePicker is disabled, if so, do not execute the logic
                                                        const isDisabled = !(getSettingsData.AssignedSpacedata?.AssignedSpace?.length > 0) ||
                                                            (getSettingsData.AssignedSpacedata?.AssignedSpace[0]?.AvailableForColleagueDates.length > 1 && index !== currentIndex);
                                                        if (!isDisabled) {
                                                            getIndex(range.StartDate, range.EndDate, range.Id, index, "datepicker");
                                                        }
                                                    }}
                                                    value={[dateFormat === 'DD/MM/YYYY' && range.StartDate ? dayjs(range.StartDate, dateFormat) : range.StartDate ? dayjs(range.StartDate) : null, dateFormat === 'DD/MM/YYYY' && range.EndDate ? dayjs(range.EndDate, dateFormat) : range.EndDate ? dayjs(range.EndDate) : null]}
                                                    onChange={(date: any, dateStrings) => handleDateChange(date, dateStrings, index, range.Id)}
                                                    format={dateFormat}
                                                />
                                                {index === 0 && <FontAwesomeIcon onClick={() => clearDateRange(index)} icon={faRemove} className={'icon_tab Tab_view'} />
                                                }
                                            </div>
                                            <div className=" col-sm-2 Tab_view">
                                                {index === 0 && <button disabled={currentIndex !== 0 || !(getSettingsData.AssignedSpacedata?.AssignedSpace?.length > 0)} className={theme === 'dark' ? 'update-button_dark ' : 'update-button'} onClick={() => handleSave(range.StartDate, range.EndDate, range.Id, index)}><FontAwesomeIcon icon={faSave} className='icon' />{t('Save')}</button>
                                                }
                                                {/* {index === 0 && <FontAwesomeIcon id="clear_icon" onClick={() => clearDateRange(index)} icon={faRemove} className={'icon_tab'} />
                                                } */}
                                                {index !== 0 && <FontAwesomeIcon icon={currentIndex === index ? faSave : faEdit} onClick={() => currentIndex === index ?
                                                    handleSave(range.StartDate, range.EndDate, range.Id, index) : getIndex(range.StartDate, range.EndDate, range.Id, index, "Edit")} className="icon pointer" style={{ marginTop: "27px" }} />
                                                }
                                                {index !== 0 && (currentIndex !== index) && <DeleteAction className='paddleft1 pointer' deleteMessage1={deleteMessage1} deleteMessage2={deleteMessage2} deleteLabel={deleteLabel} Day={range.StartDate + ' - ' + range.EndDate}
                                                    triggerdelete={() => handleDelete(range.StartDate, range.EndDate, range.Id, index)} />}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 view">
                                        {index === 0 && <label className={theme === 'dark' ? 'label-head_dark ' : 'label-head '} style={{ marginLeft: "-10px" }} >{t('EndDate')}</label>}
                                        <div className='col-md-12'>
                                        </div>
                                    </div>
                                    <div className="col-md-4 view">
                                        {index === 0 && <button disabled={currentIndex !== 0 || !(getSettingsData.AssignedSpacedata?.AssignedSpace?.length > 0)} className={theme === 'dark' ? 'update-button_dark ' : 'update-button'} onClick={() => handleSave(range.StartDate, range.EndDate, range.Id, index)}><FontAwesomeIcon icon={faSave} className='icon' />{t('Save')}</button>
                                        }
                                        {index === 0 && <FontAwesomeIcon id="clear_icon" onClick={() => clearDateRange(index)} icon={faRemove} className={'icon'} />
                                        }
                                        {index !== 0 && <FontAwesomeIcon icon={currentIndex === index ? faSave : faEdit} onClick={() => currentIndex === index ?
                                            handleSave(range.StartDate, range.EndDate, range.Id, index) : getIndex(range.StartDate, range.EndDate, range.Id, index, "Edit")} className="icon pointer padd-left1" style={{ marginTop: "27px" }} />
                                        }
                                        {index !== 0 && (currentIndex !== index) && <DeleteAction className=' pointer' deleteMessage1={deleteMessage1} deleteMessage2={deleteMessage2} deleteLabel={deleteLabel} Day={range.StartDate + ' - ' + range.EndDate}
                                            triggerdelete={() => handleDelete(range.StartDate, range.EndDate, range.Id, index)} />}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="col-md-2"></div>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default AssignedSpacePage;